import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PersonIcon from '@mui/icons-material/Person';
import FeedbackButtons from './FeedbackButtons';

const MessageContainer = styled(Box)(({ theme, isUser }) => ({
  display: 'flex',
  marginBottom: theme.spacing(2),
  flexDirection: isUser ? 'row-reverse' : 'row',
}));

const MessageBubble = styled(Box)(({ theme, isUser, isError }) => ({
  maxWidth: '80%',
  padding: theme.spacing(1.5, 2),
  borderRadius: theme.spacing(2),
  backgroundColor: isUser
    ? theme.palette.primary.main
    : isError
      ? theme.palette.error.light
      : theme.palette.grey[100],
  color: isUser || isError
    ? theme.palette.primary.contrastText
    : theme.palette.text.primary,
  marginLeft: isUser ? 0 : theme.spacing(1),
  marginRight: isUser ? theme.spacing(1) : 0,
  boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    width: 0,
    height: 0,
    borderTop: '8px solid transparent',
    borderBottom: '8px solid transparent',
    top: '50%',
    transform: 'translateY(-50%)',
    ...(isUser
      ? {
          borderRight: `8px solid ${theme.palette.primary.main}`,
          right: '-8px',
        }
      : {
          borderLeft: `8px solid ${isError ? theme.palette.error.light : theme.palette.grey[100]}`,
          left: '-8px',
        }),
  },
}));

const StyledAvatar = styled(Avatar)(({ theme, isUser }) => ({
  backgroundColor: isUser ? theme.palette.secondary.main : theme.palette.primary.main,
  width: theme.spacing(4),
  height: theme.spacing(4),
}));

const MessageText = styled(Typography)({
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
});

const ChatMessage = ({ message, isUser, onFeedback }) => {
  return (
    <Box>
      <MessageContainer isUser={isUser}>
        <StyledAvatar isUser={isUser}>
          {isUser ? <PersonIcon /> : <SmartToyIcon />}
        </StyledAvatar>
        <MessageBubble isUser={isUser} isError={message.isError}>
          <MessageText variant="body2">
            {message.text}
          </MessageText>
        </MessageBubble>
      </MessageContainer>

      {/* Only show feedback buttons for bot messages that are not errors */}
      {!isUser && !message.isError && onFeedback && (
        <Box ml={6} mr={2}>
          <FeedbackButtons
            messageId={message.id || message.timestamp}
            onFeedback={onFeedback}
          />
        </Box>
      )}
    </Box>
  );
};

export default ChatMessage;
